import { createReducer, on } from '@ngrx/store';
import { initialProjectState, projectAdapter } from './project.state';
import { ProjectActions } from './project.actions';

export const projectReducer = createReducer(
    initialProjectState,
    on(ProjectActions.loadProjects, (state) => ({
        ...state,
        loading: true,
        errorMessage: null
    })),
    on(ProjectActions.loadProjectsSuccess, (state, action) => {
        return projectAdapter.setAll(action.projects, {
            ...state,
            loading: false,
            errorMessage: null
        });
    }),
    on(ProjectActions.loadProjectsFail, (state, action) => ({
        ...state,
        loading: false,
        errorMessage: action.error
    })),
    on(ProjectActions.loadProjectByIdSuccess, (state, action) => ({
        ...state,
        selectedProject: action.project,
        loading: false,
        errorMessage: null
    })),
    on(ProjectActions.loadProjectByIdFail, (state, action) => ({
        ...state,
        loading: false,
        errorMessage: action.error
    })),
    on(ProjectActions.setSelectedProject, (state, action) => ({
        ...state,
        selectedProject: action.project
    })),
    on(ProjectActions.clearSelectedProject, (state) => ({
        ...state,
        selectedProject: null
    })),
    on(ProjectActions.clearProjects, (state) => {
        return projectAdapter.removeAll({
            ...state,
            selectedProject: null,
            loading: false,
            errorMessage: null
        });
    })
);
